/*
 * cluutch-charly-boutique.js
 * Hôtel Charly (13/10/2026) : sur une fiche épuisée, le bouton d'achat dit « Disponible aux
 * Galeries Lafayette Paris Haussmann » à la place d'« Épuisé ».
 *
 * La phrase s'affiche par cluutch-charly-boutique.css, depuis l'attribut `data-cluutch-boutique` du
 * bouton (rendu et traduit par Liquid) ; le libellé « Épuisé » reste dans la page, caché à l'œil et
 * gardé pour les lecteurs d'écran. Ce script ne tient à jour que l'attribut `data-cluutch-epuise`
 * du bouton quand la teinte change (Bang Balm : Coffee For Two épuisé, les deux autres en vente).
 * L'état initial est rendu côté serveur, correct dès le chargement (`?variant=` compris).
 *
 * Choix structurants :
 * - on ne réécrit PAS le libellé : product.js, cluutch-pdp-2026.js et le lecteur de tutos le
 *   réécrivent chacun en textContent (product.js seulement à la fin du Section Rendering, jusqu'à
 *   14 s mesurées) ; un texte posé ici serait écrasé, la phrase CSS ne l'est jamais ;
 * - on suit l'événement `product:variant-change` et sa variante, pas l'attribut `disabled` du
 *   bouton (product.js le pose le temps du Section Rendering à CHAQUE changement de teinte, la
 *   phrase clignoterait sur une teinte en vente), ni la classe `sold-out` (jamais retirée par
 *   product.js) ;
 * - zone SCOPÉE par detail.sectionId : le même snippet d'achat est rendu par le quick-view et par
 *   la section « produit en vedette » ; seul le bouton portant `data-cluutch-boutique` est touché
 *   (pas la barre collante ni le bouton flottant, qui gardent « Épuisé ») ;
 * - garde sur detail : custom.js re-diffuse le même événement SANS detail ;
 * - pas de variante (combinaison inexistante) : « Épuisé » / « Indisponible » reste, ce n'est pas
 *   la même chose qu'un épuisement.
 * Chargé par snippets/product-add-to-cart.liquid, uniquement pour les fiches Hôtel Charly.
 * Auteur : Cluutch / Studio Hogo.
 */
(function () {
	if (window.cluutchCharlyBoutiqueReady) return;
	window.cluutchCharlyBoutiqueReady = true;

	document.addEventListener('product:variant-change', function (e) {
		if (!e.detail || !e.detail.sectionId) return;

		var portee = document.querySelector('product-form[data-section="' + e.detail.sectionId + '"]');
		if (!portee) return;

		var epuisee = !!e.detail.variant && e.detail.variant.available === false;
		portee.querySelectorAll('.single-add-to-cart-button[data-cluutch-boutique]').forEach(function (bouton) {
			bouton.setAttribute('data-cluutch-epuise', epuisee ? 'true' : 'false');
		});
	});
})();
